// extracted by mini-css-extract-plugin
export default {"blockContainer":"RenderElements_blockContainer__2dCFo"};